import { IFeature } from 'app-template-lib/utils';
import { IRoute } from 'app-template-lib/utils';
import { ISideNavItem } from 'app-template-lib/utils';
import { ReactNode } from 'react';
import { TContentsContentParams, TContentsHeaderParams } from '../../../shared/t-contents-params';
import { routeItems } from './route-items';

/**
 * SampleA の機能を提供します。
 */
export class OpenProject implements IFeature<TContentsHeaderParams, TContentsContentParams> {
    /**
     * ID
     */
    id: string = '55b65df3-cc09-4287-8f82-d3b4b28ccbb0';
    /**
     * React Router のルートを取得します。
     */
    getRoutes: IRoute<TContentsHeaderParams, TContentsContentParams>[] = routeItems;
    /**
     * サイドナビゲーションを取得します。
     */
    getSideNavs: ISideNavItem[] = [];
    /**
     * サイドナビゲーションエクスプローラーアクションを取得します。
     */
    getSideNavExplorerActions: ReactNode[] = [];
    /**
     * トップアクションを取得します。
     */
    getTopActions: ReactNode[] = [];

    getProviders: React.ReactElement[] = [];
    /**
     * 初期化します。
     */
    init() {
        //初期化処理があればここに記述します。
    }
}
